import { reject } from "ramda";
import {
  PUSH_NOTIFICATION_TO_QUEUE,
  REMOVE_NOTIFICATION_FROM_QUEUE
} from "../constants/ActionTypes";

const notification = (state = [], action) => {
  switch (action.type) {
    case PUSH_NOTIFICATION_TO_QUEUE:
      return [...state, action.notification];
    case REMOVE_NOTIFICATION_FROM_QUEUE:
      return reject(({ id }) => id === action.id, state);
    default:
      return state;
  }
};

export default notification;
